import { useState, Children, cloneElement } from "react";
import { transferSVGProperties } from "../../../src/_helpers/_dom";

const SVGImage = ({
  children,
  color = "purple-semi-dark",
  filled = true,
  style = {},
  fillOutline = false,
  returnBase64 = false,
  ...props
}) => {
  const [svgImage, setSvgImage] = useState(null);

  if (!svgImage) {
    return (
      <span
        ref={(el) => {
          if (el) {
            if (!returnBase64) {
              setSvgImage(el.firstChild);
            } else {
              const string = new XMLSerializer().serializeToString(
                el.firstChild
              );
              setSvgImage(`data:image/svg+xml;base64,${window.btoa(string)}`);
            }
          }
        }}
      >
        {Children.map(children, (child) => {
          const props = { ...child.props };
          if (
            child.props.hasOwnProperty("width") &&
            child.props.hasOwnProperty("height") &&
            !child.props.hasOwnProperty("viewBox")
          ) {
            props.viewBox = `0 0 ${props.width} ${props.height}`;
          }
          if (!child.props.hasOwnProperty("style")) {
            props.style = style;
          }
          return cloneElement(child, props);
        })}
      </span>
    );
  }

  if (returnBase64) {
    return <img src={svgImage} alt="" {...props} />;
  }

  return (
    <svg
      ref={(el) => {
        if (el) {
          transferSVGProperties(el, svgImage);
        }
      }}
    />
  );
};

export default SVGImage;
